// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__yfQ_d","dots":"Pagination_dots__aBfT6","dot":"Pagination_dot__urVqZ","active":"Pagination_active__5Ws95","buttons":"Pagination_buttons__8QMLq"};